import request from '@/utils/request';
import type { ApiResponse } from '@/types';

/** 评论记录 */
export interface CommentRecord {
  id: number;
  type: string;
  targetId: number;
  name: string;
  content: string;
  avatar: string;
  likes: number;
  createdAt: string;
  ip: string;
}

/** 创建评论 */
export const createComment = (data: {
  type: string;
  targetId: number;
  name: string;
  content: string;
  avatar: string;
}): Promise<ApiResponse<CommentRecord>> =>
  request.post('/comment/create', data) as Promise<ApiResponse<CommentRecord>>;

/** 获取评论列表 */
export const getCommentList = (params: {
  type: string;
  targetId: number;
}): Promise<ApiResponse<{ list: CommentRecord[]; total: number }>> =>
  request.get('/comment/list', { params }) as Promise<ApiResponse<{ list: CommentRecord[]; total: number }>>;

/** 点赞评论 */
export const likeComment = (id: number): Promise<ApiResponse<null>> =>
  request.post('/comment/like', { id }) as Promise<ApiResponse<null>>;

/** 删除评论 */
export const deleteComment = (id: number): Promise<ApiResponse<null>> =>
  request.post('/comment/delete', { id }) as Promise<ApiResponse<null>>;
